import reduce from 'lodash/reduce';

const row1Shift = ['!', '@', '#', '$', '%', '&', '(', ')'];

const rowNumber = [
  { name: 'tilde', character: '`', alt: '~' },
  { name: '1', character: '1', alt: '!' },
  { name: '2', character: '2', alt: '@' },
  { name: '3', character: '3', alt: '#' },
  { name: '4', character: '4', alt: '$' },
  { name: '5', character: '5', alt: '%' },
  { name: '6', character: '6', alt: '^' },
  { name: '7', character: '7', alt: '&' },
  { name: '8', character: '8', alt: '*' },
  { name: '9', character: '9', alt: '(' },
  { name: '0', character: '0', alt: ')' },
  { name: 'dash', character: '-', alt: '_' },
  { name: 'equal', character: '=', alt: '+' },
  { name: 'backspace', character: 'backspace' }
];

const row1 = [
  { name: 'Tab', character: 'tab' },
  { name: 'q', character: 'q', alt: 'Q' },
  { name: 'w', character: 'w', alt: 'W' },
  { name: 'e', character: 'e', alt: 'E' },
  { name: 'r', character: 'r', alt: 'R' },
  { name: 't', character: 't', alt: 'T' },
  { name: 'y', character: 'y', alt: 'Y' },
  { name: 'u', character: 'u', alt: 'U' },
  { name: 'i', character: 'i', alt: 'I' },
  { name: 'o', character: 'o', alt: 'O' },
  { name: 'p', character: 'p', alt: 'P' },
  { name: 'bracket1', character: '[', alt: '{' },
  { name: 'bracket2', character: ']', alt: '}' },
  { name: 'bslash', character: '\\', alt: '|' }
];

const row2 = [
  { name: 'CapLock', character: 'CapLock' },
  { name: 'a', character: 'a', alt: 'A' },
  { name: 's', character: 's', alt: 'S' },
  { name: 'd', character: 'd', alt: 'D' },
  {
    name: 'f',
    character: 'f',
    alt: 'F',
    hold: 'left'
  },
  { name: 'g', character: 'g', alt: 'G' },
  { name: 'h', character: 'h', alt: 'H' },
  {
    name: 'j',
    character: 'j',
    alt: 'J',
    hold: 'right'
  },
  { name: 'k', character: 'k', alt: 'K' },
  { name: 'l', character: 'l', alt: 'L' },
  { name: 'semicolon', character: ';', alt: ':' },
  { name: 'apost', character: "'", alt: '"' },
  { name: 'enter', character: 'enter' }
];

const row3 = [
  {
    name: 'shift1',
    character: 'shift1',
    shift: true,
    hold: 'left'
  },
  { name: 'z', character: 'z', alt: 'Z' },
  { name: 'x', character: 'x', alt: 'X' },
  { name: 'c', character: 'c', alt: 'C' },
  { name: 'v', character: 'v', alt: 'V' },
  { name: 'b', character: 'b', alt: 'B' },
  { name: 'n', character: 'n', alt: 'N' },
  { name: 'm', character: 'm', alt: 'M' },
  { name: 'comma', character: ',', alt: '<' },
  { name: 'period', character: '.', alt: '>' },
  { name: 'fslash', character: '/', alt: '?' },
  {
    name: 'shift2',
    character: 'shift2',
    shift: true,
    hold: 'right'
  }
];

const row4 = [{ character: ' ', name: 'space' }];

const keys = {
  row1: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'].concat(row1Shift),
  row2: ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
  row3: ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', "'"],
  row4: ['z', 'x', 'c', 'v', 'b', 'n', 'm', ',', '.', '?'],
  row5: [' ']
};

export const keyLayout = [
  { name: 'rowNumber', order: 0, keys: rowNumber },
  { name: 'row1', order: 1, keys: row1 },
  { name: 'row2', order: 2, keys: row2 },
  { name: 'row3', order: 3, keys: row3 },
  { name: 'row4', order: 4, keys: row4 }
].sort((a, b) => a.order > b.order);

export default keys;

export const holdKeys = ['f', 'j'];

const createMap = () => {
  const map = {};

  return {
    set(key, value) {
      map[key] = value;
    },

    get(key) {
      return map[key];
    }
  };
};

export const characterMap = reduce(
  keys,
  (mapAcc, chars, rowName) => {
    chars.forEach(char => mapAcc.set(char, rowName));

    return mapAcc;
  },
  createMap()
);
